import {HttpModelConverter} from "../../../../../../../core/converter/httpModel.converter";
import {Injectable} from "@angular/core";
import {PermissionsConverter} from "../../../../../../../common/converter/permissions.converter";
import {TreatmentJourneyStepSummaryModel} from "./treatmentJourneyStepSummary.model";
import {DateConverter} from "../../../../../../../common/converter/date.converter";
import {
    LovValueSummaryConverter
} from "../../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";
import {TreatmentJourneyStepModel} from "./treatmentJourneyStep.model";
import {
    ConsultationCategorySummaryConverter
} from "../../../../../../consultation/category/api/model/converter/consultationCategorySummary.converter";
import {
    TreatmentDefinitionSummaryConverter
} from "../../../../../treatment-definition/api/entity/converter/treatmentDefinitionSummary.converter";
import {TreatmentJourneyStepSummaryConverter} from "./treatmentJourneyStepSummary.converter";
import {TreatmentJourneyStepFeedbackConverter} from "./treatmentJourneyStepFeedback.converter";
import {TreatmentJourneyStepReminderConverter} from "./treatmentJourneyStepReminder.converter";

@Injectable({
    providedIn: 'root'
})
export class TreatmentJourneyStepConverter extends HttpModelConverter<TreatmentJourneyStepModel> {

    constructor(private consultationCategorySummaryConverter: ConsultationCategorySummaryConverter,
                private treatmentDefinitionSummaryConverter: TreatmentDefinitionSummaryConverter,
                private summaryConverter: TreatmentJourneyStepSummaryConverter,
                private feedbackConverter: TreatmentJourneyStepFeedbackConverter,
                private reminderConverter: TreatmentJourneyStepReminderConverter) {
        super();
    }

    protected createInstance(): TreatmentJourneyStepModel {
        return new TreatmentJourneyStepModel();
    }

    protected enrichObject(result: TreatmentJourneyStepModel, src: TreatmentJourneyStepModel) {
        result.consultationCategory = this.consultationCategorySummaryConverter.convert(src.consultationCategory);
        result.treatmentFormDefinition = this.treatmentDefinitionSummaryConverter.convert(src.treatmentFormDefinition);
        result.summary = this.summaryConverter.convert(src.summary);
        result.feedbacks = this.feedbackConverter.convertFromArray(src.feedbacks);
        result.reminders = this.reminderConverter.convertFromArray(src.reminders);
    }
}